/* HVAC-064-DI */
(function () {
  function initSection(root) {
    if (!root || root.dataset.goodmanGridV2Init === 'true') return;
    root.dataset.goodmanGridV2Init = 'true';

    const filterButtons = root.querySelectorAll('[data-goodman-filter]');
    const cards = Array.from(root.querySelectorAll('[data-goodman-filters]'));
    const groups = root.querySelectorAll('[data-goodman-group]');
    const filteredGroup = root.querySelector('[data-goodman-filtered-group]');
    const filteredTrack = filteredGroup ? filteredGroup.querySelector('[data-goodman-track]') : null;
    const carousels = [];

    const cardHomes = cards.map((card) => ({
      card,
      parent: card.parentElement,
      index: Array.from(card.parentElement.children).indexOf(card),
    }));

    function syncNav(carousel) {
      const { track, prev, next } = carousel;
      if (!track) return;

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const left = track.scrollLeft;
      const atStart = left <= 1;
      const atEnd = left >= maxScroll - 1;

      if (prev) {
        prev.disabled = atStart;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (next) {
        next.disabled = atEnd || maxScroll <= 1;
        next.setAttribute('aria-disabled', next.disabled ? 'true' : 'false');
      }
    }

    function restoreCards() {
      const byParent = new Map();
      cardHomes.forEach((home) => {
        if (!byParent.has(home.parent)) byParent.set(home.parent, []);
        byParent.get(home.parent).push(home);
      });
      byParent.forEach((homes, parent) => {
        homes
          .slice()
          .sort((a, b) => a.index - b.index)
          .forEach(({ card }) => {
            parent.appendChild(card);
          });
      });
    }

    function applyFilter(filterKey) {
      const isFiltered = filterKey !== 'all';
      root.classList.toggle('is-filtered', isFiltered);

      if (!isFiltered || !filteredGroup || !filteredTrack) {
        restoreCards();
        cards.forEach((card) => {
          card.hidden = false;
        });
        groups.forEach((group) => {
          group.hidden = false;
        });
        if (filteredGroup) filteredGroup.hidden = true;
      } else {
        groups.forEach((group) => {
          group.hidden = true;
        });
        filteredGroup.hidden = false;

        cards.forEach((card) => {
          const filters = (card.getAttribute('data-goodman-filters') || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean);
          const visible = filters.includes(filterKey);
          card.hidden = !visible;
          if (visible) {
            filteredTrack.appendChild(card);
          }
        });
      }

      filterButtons.forEach((button) => {
        const isActive = button.getAttribute('data-goodman-filter') === filterKey;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      carousels.forEach((carousel) => {
        carousel.track.scrollLeft = 0;
      });
      requestAnimationFrame(() => {
        carousels.forEach(syncNav);
      });
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        applyFilter(button.getAttribute('data-goodman-filter') || 'all');
      });
    });

    root.querySelectorAll('[data-goodman-carousel]').forEach((rootCarousel) => {
      const track = rootCarousel.querySelector('[data-goodman-track]');
      const prev = rootCarousel.querySelector('[data-goodman-prev]');
      const next = rootCarousel.querySelector('[data-goodman-next]');
      if (!track) return;

      const carousel = { track, prev, next };
      carousels.push(carousel);

      function scrollByCard(direction) {
        if (direction < 0 && prev?.disabled) return;
        if (direction > 0 && next?.disabled) return;

        const card = track.querySelector('[data-goodman-filters]:not([hidden])');
        const amount = card ? card.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', () => scrollByCard(-1));
      if (next) next.addEventListener('click', () => scrollByCard(1));

      track.addEventListener('scroll', () => syncNav(carousel), { passive: true });
      window.addEventListener('resize', () => syncNav(carousel));
      syncNav(carousel);
    });

    applyFilter('all');
  }

  function initAll() {
    document.querySelectorAll('[data-goodman-systems-grid-v2]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-goodman-systems-grid-v2]');
    if (root) {
      root.dataset.goodmanGridV2Init = '';
      initSection(root);
    }
  });
})();
